import { render } from "./Selectable.vue?vue&type=template&id=4bd6096e"
import script from "./Selectable.vue?vue&type=script&lang=js"
export * from "./Selectable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__